import { FormEvent, useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import { ApiError } from '../../api/client.js';
import { APP_TITLE } from '../../config.js';
import { useAuth } from './AuthProvider.js';

export const LoginPage = () => {
  const { login, status } = useAuth();
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      await login(password);
      setPassword('');
    } catch (unknownError) {
      if (unknownError instanceof ApiError && unknownError.status === 401) {
        setError('Nesprávné heslo. Zkuste to prosím znovu.');
      } else {
        setError('Přihlášení se nezdařilo. Zkuste to znovu později.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        py: 6,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          component="form"
          onSubmit={handleSubmit}
          sx={{ p: { xs: 3, md: 4 }, display: 'flex', flexDirection: 'column', gap: 3 }}
        >
          <Stack spacing={1}>
            <Typography variant="h4" fontWeight={600}>
              {APP_TITLE}
            </Typography>
            <Typography color="text.secondary">
              Přihlaste se heslem, pokud nejste v interní síti.
            </Typography>
          </Stack>

          <TextField
            label="Heslo"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            disabled={submitting || status === 'loading'}
            required
            fullWidth
          />

          {error ? <Alert severity="error">{error}</Alert> : null}

          <Button
            type="submit"
            size="large"
            disabled={password.length === 0 || submitting}
          >
            {submitting ? 'Přihlašuji…' : 'Přihlásit se'}
          </Button>

          <Typography variant="body2" color="text.secondary">
            Přístup z interní sítě je automaticky povolen, heslo není potřeba.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};
